import { Star, StarOff } from 'lucide-react';
import React from 'react';
import { CellProps } from '.';
import UIStrings from '@/Utils/UIStrings';
import { useCandidatesOverviewContext } from '../../CandidatesOverviewContext/CandidatesOverviewContext';
import { Button } from '@/Components/shadcn';

function FavoriteCell({ candidate: { candidateId, isFavorite } }: CellProps): React.JSX.Element {
    const { saveFavoriteAsync } = useCandidatesOverviewContext();

    const handleFavoriteOnClick = () => {
        saveFavoriteAsync(candidateId, !isFavorite);
    };

    return (
        <Button
            variant="ghost"
            size="icon-sm"
            type="button"
            aria-label={UIStrings.Favorite}
            aria-pressed={isFavorite}
            onClick={handleFavoriteOnClick}
            className="group text-primary hover:text-primary mx-auto"
        >
            <span className="relative inline-flex size-6 items-center justify-center">
                {isFavorite ? (
                    <>
                        <Star
                            aria-hidden
                            className="transition-opacity group-hover:pointer-events-none group-hover:opacity-0"
                            fill="currentColor"
                        />
                        <StarOff
                            aria-hidden
                            className="pointer-events-none absolute inset-0 m-auto opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100"
                        />
                    </>
                ) : (
                    <>
                        <Star
                            aria-hidden
                            className="transition-opacity group-hover:pointer-events-none group-hover:opacity-0"
                        />
                        <Star
                            aria-hidden
                            className="pointer-events-none absolute inset-0 m-auto opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100"
                            fill="currentColor"
                        />
                    </>
                )}
            </span>
        </Button>
    );
}

export default FavoriteCell;
